import { render, staticRenderFns } from "./AreaTitle.vue?vue&type=template&id=03054640&scoped=true"
import script from "./AreaTitle.vue?vue&type=script&lang=ts"
export * from "./AreaTitle.vue?vue&type=script&lang=ts"
import style0 from "./AreaTitle.vue?vue&type=style&index=0&id=03054640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03054640",
  null
  
)

export default component.exports